import { Typography } from '@mui/material'

function DBError () {
  return (
    <div>
      <Typography variant='h5' sx={{ mb: 2, textAlign: 'center' }}>
        We encountered an error while processing your registration.
      </Typography>

      <Typography sx={{ mt: 2, fontStyle: 'italic', textAlign: 'center' }} color='textSecondary'>
        Please try again later.
      </Typography>
    </div>
  )
}

export default DBError
